<template>
  <router-link :to="to" class="card-link">
    <v-card class="quick-access-card">
      <div class="card-background"></div>

      <v-card-text class="card-text">
        <div class="icon-container" :style="{ color }">
          <v-icon size="48">{{ icon }}</v-icon>
        </div>

        <div class="content-container">
          <h3 class="card-title">{{ title }}</h3>
          <p class="card-description">{{ description }}</p>
        </div>

        <div class="arrow-container">
          <v-icon size="24" class="arrow-icon">mdi-arrow-right</v-icon>
        </div>
      </v-card-text>
    </v-card>
  </router-link>
</template>

<script>
export default {
  name: 'QuickAccessCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#0e511a',
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.card-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.quick-access-card {
  position: relative;
  overflow: hidden;
  height: 140px;
  border-radius: 12px !important;
  background: white;
  border: 2px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.card-background {
  position: absolute;
  top: 0;
  right: -30px;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(14, 81, 26, 0.08), rgba(222, 253, 231, 0.1));
  transition: all 0.4s ease;
}

.quick-access-card:hover {
  transform: translateY(-8px);
  border-color: #0e511a;
  box-shadow: 0 12px 32px rgba(14, 81, 26, 0.15);
  background: linear-gradient(135deg, #fafaf9 0%, #f5f7f5 100%);
}

.quick-access-card:hover .card-background {
  right: -50px;
  transform: scale(1.3);
}

.card-text {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 100%;
  position: relative;
  z-index: 2;
  padding: 20px !important;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  background: rgba(14, 81, 26, 0.08);
  border-radius: 12px;
  transition: all 0.35s ease;
}

.quick-access-card:hover .icon-container {
  background: rgba(14, 81, 26, 0.15);
  transform: scale(1.1) rotate(-5deg);
}

.content-container {
  flex: 1;
  min-width: 0;
}

.card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  transition: all 0.3s ease;
}

.quick-access-card:hover .card-title {
  color: #0e511a;
}

.card-description {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #666;
  transition: all 0.3s ease;
}

.quick-access-card:hover .card-description {
  color: #555;
}

.arrow-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(14, 81, 26, 0.08);
  flex-shrink: 0;
  transition: all 0.35s ease;
}

.arrow-icon {
  color: #0e511a !important;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.quick-access-card:hover .arrow-container {
  background: rgba(14, 81, 26, 0.15);
}

.quick-access-card:hover .arrow-icon {
  transform: translateX(4px);
}

@media (max-width: 960px) {
  .quick-access-card {
    height: 130px;
  }

  .card-text {
    gap: 16px;
    padding: 16px !important;
  }

  .card-title {
    font-size: 15px;
  }

  .icon-container {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 600px) {
  .quick-access-card {
    height: 120px;
  }

  .card-text {
    gap: 12px;
    padding: 12px !important;
  }

  .icon-container {
    width: 44px;
    height: 44px;
  }

  .card-title {
    font-size: 14px;
  }

  .card-description {
    font-size: 12px;
  }

  .arrow-container {
    width: 32px;
    height: 32px;
  }

  .arrow-icon {
    font-size: 20px;
  }
}
</style>
